import { SOURCE_DOCUMENT_ACCEPT, SOURCE_INPUT_UPLOAD_HINT } from '../../../domain/sourceAttachmentPolicy';

export const aiCreateModalMarkup = String.raw`<!-- AI Create Modal — reuses 3-step wizard from Submit Idea -->
<div class="modal-overlay" id="aiCreateModal" data-transient-action>
  <div class="modal modal--lg">
    <div class="modal-header">
      <div class="modal-heading">
        <h3 class="modal-title">Create private topic</h3>
      </div>
      <button class="modal-close" type="button" data-proto-click="closeAiCreateModal()" aria-label="Close AI Create dialog">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <!-- Step indicator -->
    <div class="wizard-steps" id="aiWizardSteps">
      <div class="wizard-step active" data-step="1">
        <span class="wizard-step-num">1</span>
        <span class="wizard-step-label">Basics</span>
      </div>
      <div class="wizard-step-line"></div>
      <div class="wizard-step" data-step="2">
        <span class="wizard-step-num">2</span>
        <span class="wizard-step-label">References</span>
      </div>
      <div class="wizard-step-line"></div>
      <div class="wizard-step" data-step="3">
        <span class="wizard-step-num">3</span>
        <span class="wizard-step-label">Details</span>
      </div>
    </div>
    <div class="modal-body">
	  <p id="aiCreateFormAlert" class="operation-feedback" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
      <!-- Step 1: Title + Category -->
      <div class="wizard-panel active" id="aiWizardPanel1">
        <div style="margin-bottom:20px;">
          <label class="wizard-label" for="aiTopicTitle">Topic Title</label>
          <input type="text" class="input" id="aiTopicTitle" maxlength="120" autocomplete="off" placeholder="e.g. Advanced Prompt Engineering Patterns">
        </div>
        <div style="margin-bottom:20px;">
          <label class="wizard-label" for="aiTopicSubtitle">Subtitle <span style="font-weight:400;color:var(--fg-tertiary);">(optional)</span></label>
          <input type="text" class="input" id="aiTopicSubtitle" maxlength="120" autocomplete="off" placeholder="A short tagline shown under the title">
        </div>
        <div>
          <button type="button" class="btn btn-primary btn-lg w-full" data-proto-click="aiWizardNext(2)" style="margin-top:28px;">Continue</button>
        </div>
      </div>
      <!-- Step 2: Sources -->
      <div class="wizard-panel" id="aiWizardPanel2">
        <p style="font-size:12px;color:var(--fg-tertiary);margin:-4px 0 18px;">${SOURCE_INPUT_UPLOAD_HINT}</p>
        <div data-source-section="attachments">
          <label class="wizard-label" for="aiAttachmentInput">Attachments</label>
          <div id="aiAttachmentList" style="display:flex;flex-direction:column;gap:6px;margin-bottom:8px;"></div>
          <button type="button" id="aiAddAttachmentBtn" data-proto-click="addAiAttachment()" class="wizard-add-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
            Attach file · max 30 MB
          </button>
          <input type="file" id="aiAttachmentInput" style="display:none;" accept="${SOURCE_DOCUMENT_ACCEPT}" data-proto-change="handleAiAttachment(this)">
        </div>
        <div class="source-input-divider" aria-hidden="true"><span>OR</span></div>
        <div data-source-section="reference-links">
          <label class="wizard-label" for="aiReferenceUrl1">Reference Links</label>
          <div id="aiLinkList" style="display:flex;flex-direction:column;gap:8px;">
            <div class="idea-link-row">
              <input type="url" class="input idea-link-url" id="aiReferenceUrl1" maxlength="2048" autocomplete="off" placeholder="https://..." aria-label="Reference URL 1">
              <input type="text" class="input idea-link-desc" maxlength="64" autocomplete="off" placeholder="Link description" aria-label="Reference link description 1">
              <span style="width:32px;flex-shrink:0;"></span>
            </div>
          </div>
          <p style="font-size:11px;color:var(--fg-tertiary);margin-top:6px;">Reference links must be valid https URLs.</p>
          <button type="button" id="aiAddLinkBtn" data-proto-click="addAiLink()" class="wizard-add-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            Add another link
          </button>
        </div>
        <div class="modal-actions modal-actions--split">
          <button class="btn btn-outline btn-lg wizard-back-btn" data-proto-click="aiWizardNext(1)">
            Back
          </button>
          <button type="button" class="btn btn-primary btn-lg" data-proto-click="aiWizardNext(3)">Continue</button>
        </div>
      </div>
      <!-- Step 3: Chapter count + Strengths + Weaknesses -->
      <div class="wizard-panel" id="aiWizardPanel3">
        <div style="margin-bottom:20px;">
          <label class="wizard-label" id="aiTopicChaptersLabel">Preferred chapter count</label>
          <div class="ai-chapter-presets" role="radiogroup" aria-labelledby="aiTopicChaptersLabel">
            <label class="ai-chapter-preset">
              <input type="radio" name="aiChapterPreset" value="1-15" checked />
              <span>Auto-Plan</span>
            </label>
            <label class="ai-chapter-preset">
              <input type="radio" name="aiChapterPreset" value="1-5" />
              <span>1-5</span>
            </label>
            <label class="ai-chapter-preset">
              <input type="radio" name="aiChapterPreset" value="6-8" />
              <span>6-8</span>
            </label>
            <label class="ai-chapter-preset">
              <input type="radio" name="aiChapterPreset" value="9-12" />
              <span>9-12</span>
            </label>
            <label class="ai-chapter-preset">
              <input type="radio" name="aiChapterPreset" value="13-15" />
              <span>13-15</span>
            </label>
          </div>
          <input type="hidden" id="aiTopicChapters" value="1-15">
          <p class="ai-chapter-recommendation">Recommended: Auto-Plan — it plans 1-15 chapters around your material.</p>
          <p class="ai-chapter-credit-note" id="aiChapterCreditNote" role="status">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
            <span data-ai-chapter-credit-copy>We’ll temporarily hold up to 12 AI Credits for this run. When your topic is ready, we’ll charge only for the chapters created and return any unused credits automatically.</span>
          </p>
        </div>
        <div style="margin-bottom:20px;">
          <label class="wizard-label" for="aiTopicStrengths">What should it emphasize? <span style="font-weight:400;color:var(--fg-tertiary);">(optional)</span></label>
          <textarea class="input" id="aiTopicStrengths" rows="2" maxlength="300" autocomplete="off" placeholder="For example: a specific question, application, comparison, or decision." style="line-height:1.5;"></textarea>
        </div>
        <div style="margin-bottom:24px;">
          <label class="wizard-label" for="aiTopicWeaknesses">What should it spend less time on? <span style="font-weight:400;color:var(--fg-tertiary);">(optional)</span></label>
          <textarea class="input" id="aiTopicWeaknesses" rows="2" maxlength="300" autocomplete="off" placeholder="For example: fine-grained walkthroughs, exhaustive lists, or peripheral details." style="line-height:1.5;"></textarea>
        </div>
        <!-- Human verification: visible Turnstile widget. Submit button stays
             disabled until the user solves the challenge and a token is cached. -->
        <div id="aiTurnstileContainer" style="margin-bottom:20px;min-height:0;text-align:center;"></div>
        <div class="modal-actions modal-actions--split">
          <button class="btn btn-outline btn-lg wizard-back-btn" data-proto-click="aiWizardNext(2)">
            Back
          </button>
          <button class="btn btn-primary btn-lg" id="aiSubmitBtn" data-proto-click="submitAiTopic()" data-transient-action data-idle-disabled="true" style="position:relative;" disabled>
            <span style="display:inline-flex;align-items:center;gap:8px;"><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z"></path></svg>Generate Topic</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Low-range chapter warning: shown when the user explicitly picks 1-5 while a
     larger range is available. Confirm keeps 1-5; cancel restores the previous
     selection (overlay click / Esc route through the same cancel action). -->
<div class="modal-overlay" id="aiChapterLowRangeModal" hidden>
  <div class="modal modal--xs">
    <div class="modal-body">
      <h3 class="modal-title" style="margin-bottom:8px;">1-5 chapters may skip detail</h3>
      <p class="modal-copy">A 1-5 chapter range can miss important details or leave chapter themes unfocused. We generally recommend a larger range for richer coverage.</p>
      <div class="modal-actions">
        <button type="button" class="btn btn-outline btn-lg" data-proto-click="closeAiChapterLowRange()">Cancel</button>
        <button type="button" class="btn btn-primary btn-lg" data-proto-click="confirmAiChapterLowRange()">Still select 1-5</button>
      </div>
    </div>
  </div>
</div>

`;
